// surroundings-view.js — Abschnitt „In der Umgebung“ als HTML-Text (App und öffentliche Platzseite teilen ihn).
// Die CommonJS-Fassung lib/surroundings-view.js wird ERZEUGT: node scripts/gen-surroundings-twin.cjs (Test prüft das).
// META muss zu lib/surroundings.js CATEGORIES passen (Test). Texte: Gruppe `near`.

export const META = {
  beach: ['water', 'beach_access'], sea: ['water', 'waves'], lake: ['water', 'water'], river: ['water', 'water'], swim: ['water', 'pool'],
  hiking: ['active', 'hiking', 'count'], cycling: ['active', 'directions_bike', 'count'], climbing: ['active', 'landscape'],
  boat: ['active', 'kayaking'], fishing: ['active', 'phishing'], riding: ['active', 'pets'], golf: ['active', 'flag'], ski: ['active', 'downhill_skiing'],
  castle: ['trips', 'castle'], museum: ['trips', 'museum'], zoo: ['trips', 'pets'], viewpoint: ['trips', 'landscape'],
  attraction: ['trips', 'photo_camera'], nature: ['trips', 'forest'],
  supermarket: ['supply', 'shopping_cart'], bakery: ['supply', 'bakery_dining'], restaurant: ['supply', 'restaurant'],
  pharmacy: ['supply', 'local_pharmacy'], fuel: ['supply', 'local_gas_station'], train: ['supply', 'train'], bus: ['supply', 'directions_bus'],
};
export const GROUPS = ['water', 'active', 'trips', 'supply'];
const GROUP_ICON = { water: 'waves', active: 'hiking', trips: 'explore', supply: 'shopping_cart' };

/** Entfernung lesbar: 0 = am Platz, unter 1 km auf 50 m (mindestens 50 m), darüber auf 0,1 km. o.num(x, digits) formatiert. */
export function distText(m, o) {
  if (m == null) return '';
  if (m < 25) return o.t('near.here');
  if (m < 1000) return o.t('near.m', { n: Math.max(50, Math.round(m / 50) * 50) });
  return o.t('near.km', { n: o.num(Math.round(m / 100) / 10) });
}

/** Kurzangaben (wie lib/surroundings.js summarize): Wasser zuerst, dann Routen, dann nahe Ausflugsziele. */
export function highlights(data, max = 5) {
  const cats = (data && data.cats) || {};
  const near = (k) => (cats[k] && cats[k].items[0] && cats[k].items[0].m != null ? cats[k].items[0].m : null);
  const water = ['beach', 'sea', 'lake', 'river', 'swim'].filter((k) => near(k) != null && near(k) <= 5000)
    .sort((a, b) => near(a) - near(b)).map((k) => ({ key: k, m: near(k) }));
  const routes = ['hiking', 'cycling'].filter((k) => cats[k] && cats[k].n > 0).map((k) => ({ key: k, n: cats[k].n }));
  const trips = ['castle', 'zoo', 'museum', 'nature', 'climbing', 'ski'].filter((k) => near(k) != null && near(k) <= 10000)
    .sort((a, b) => near(a) - near(b)).map((k) => ({ key: k, m: near(k) }));
  return [...water, ...routes, ...trips].slice(0, max);
}

/**
 * HTML des Abschnitts. o = { t(key, vars), esc, num(x), date(d) → Text, open: Set(Gruppen offen), map: true = Knöpfe
 * „auf der Karte“ (nur App) }. Ohne Daten: ''. Ohne Funde: kurzer Hinweis.
 */
export function surroundingsHtml(data, o) {
  if (!data || !data.cats) return '';
  const cats = data.cats;
  const e = o.esc;
  const hl = highlights(data);
  const label = (k) => o.t('near.c_' + k);
  const chips = hl.map((h) => '<li class="vc-near-chip"><span class="vc-icon" aria-hidden="true">' + META[h.key][1] + '</span>'
    + '<span>' + e(label(h.key)) + '</span><span class="vc-near-dist">'
    + e(h.n != null ? (h.n === 1 ? o.t('near.routes_chip_one') : o.t('near.routes_chip', { n: h.n })) : distText(h.m, o)) + '</span></li>').join('');
  const groups = GROUPS.map((g) => {
    const keys = Object.keys(META).filter((k) => META[k][0] === g && cats[k] && (cats[k].n > 0));
    if (!keys.length) return '';
    const rows = keys.map((k) => {
      const c = cats[k];
      if (META[k][2] === 'count') {
        const names = (c.items || []).map((i) => i.name).filter(Boolean).slice(0, 4);
        return '<li class="vc-near-row"><span class="vc-icon" aria-hidden="true">' + META[k][1] + '</span><span class="vc-near-text">'
          + '<span class="vc-near-cat">' + e(label(k)) + '</span><span class="vc-near-names">' + e(names.join(' · ') || '') + '</span></span>'
          + '<span class="vc-near-dist">' + e(c.n === 1 ? o.t('near.routes_one') : o.t('near.routes', { n: c.n })) + '</span></li>';
      }
      const items = (c.items || []).map((i) => {
        const where = (k === 'nature' && i.m === 0) ? o.t('near.inside') : distText(i.m, o);
        const btn = o.map && i.lat != null ? '<button type="button" class="vc-icon-btn is-xs" data-near-map="' + i.lat + ',' + i.lng
          + '" aria-label="' + e(o.t('near.on_map') + ': ' + (i.name || label(k))) + '"><span class="vc-icon" aria-hidden="true">near_me</span></button>' : '';
        return '<li class="vc-near-item"><span class="vc-near-name">' + e(i.name || label(k)) + '</span><span class="vc-near-dist">' + e(where) + '</span>' + btn + '</li>';
      }).join('');
      return '<li class="vc-near-row"><span class="vc-icon" aria-hidden="true">' + META[k][1] + '</span><span class="vc-near-text">'
        + '<span class="vc-near-cat">' + e(label(k)) + (c.n > (c.items || []).length ? ' <span class="vc-near-count">' + e(o.t('near.count', { n: c.n })) + '</span>' : '')
        + '</span><ul class="vc-near-items">' + items + '</ul></span></li>';
    }).join('');
    return '<details class="vc-near-group" data-near-group="' + g + '"' + (o.open && o.open.has(g) ? ' open' : '') + '>'
      + '<summary><span class="vc-icon" aria-hidden="true">' + GROUP_ICON[g] + '</span><span class="vc-near-gtitle">' + e(o.t('near.g_' + g)) + '</span>'
      + '<span class="vc-icon vc-near-chev" aria-hidden="true">expand_more</span></summary><ul class="vc-near-rows">' + rows + '</ul></details>';
  }).join('');
  const body = (chips || groups)
    ? (chips ? '<ul class="vc-near-chips">' + chips + '</ul>' : '') + groups
    : '<p class="vc-near-none">' + e(o.t('near.none')) + '</p>';
  const stand = data.checked_at ? o.date(data.checked_at) : '';
  return '<section class="vc-near" aria-labelledby="vc-near-h"><h2 id="vc-near-h" class="vc-near-h">' + e(o.t('near.title')) + '</h2>'
    + body + '<p class="vc-near-src">' + e(o.t('near.source', { date: stand })) + '</p></section>';
}
